<nav class="ba-breadcrumb" [attr.aria-label]="('breadcrumb.info' | i18next) ">
    <ol>
        <li><a href="https://www.arbeitsagentur.de" [title]="'breadcrumb.homepage' |  i18next"
               id="breadcrumb-startseite">{{ "breadcrumb.homepage" | i18next }}</a></li>
        <li><a href="https://web.arbeitsagentur.de/profil/profil-ui/pd/" [title]="'breadcrumb.profile' |  i18next"
               id="breadcrumb-profil">{{ "breadcrumb.profile" | i18next }}</a></li>
        @if (!isPostfach) {
            <li><a href="https://web.arbeitsagentur.de/kokos/kokos-ui/pd/" [title]="postfachLabel"
                   id="breadcrumb-postfach">{{ postfachLabel }}</a></li>
        }
    </ol>
</nav>
